export default "__VITE_PUBLIC_ASSET__862009e0__"